import React, { useState } from "react";
import TickIcon from "../../../assets/icons/ABHA-icons/tick-icon";
import DownloadIcon from "../../../assets/icons/ABHA-icons/download-icon";
import ShareIcon from "../../../assets/icons/ABHA-icons/share-icon";
import PrintIcon from "../../../assets/icons/ABHA-icons/print-icon";
import EmailIcon from "../../../assets/icons/ABHA-icons/email-icon";
import HealthInsuranceIcon from "../../../assets/icons/admin-customer-icons/health-insurance-icon";
import HealthIcon from "../../../assets/icons/ABHA-icons/health-icon";
import QR from "../../../assets/images/abha-imgs/QR.png";
import InfoIcon from "../../../assets/icons/ABHA-icons/info-icon";
import BulbIcon from "../../../assets/icons/ABHA-icons/bulb-icon";
import AddButton from "../../buttons/button";
import moment from "moment";
import { url } from "../../../redux/config";
import axios from "axios";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import { CopyIcon, Share2Icon } from "lucide-react";

// function Confirmation({
//   closeModal,
//   setStatus,
//   setPosition,
//   adhaarSuccessData,
//   adhaarX_Token,
//   adhaarAccessToken,
// }) {
//   const [loading, setLoading] = useState(false);
//   const [qrImageUrl, setQrImageUrl] = useState(null);
//   const [qrBlob, setQrBlob] = useState(null);
//   const [shareQRUrl, setShareQRUrl] = useState(null);

//   const downloadQR = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${url}/abha-integration/abha-qr-code-download`,
//         {
//           x_token: adhaarX_Token,
//           accessToken: adhaarAccessToken,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           responseType: "blob", // This is crucial for binary data
//         }
//       );

//       console.log("Response:", response);

//       // Create blob and download immediately
//       const blob = new Blob([response.data], { type: "image/png" });
//       const imageUrl = URL.createObjectURL(blob);

//       // Create download link and trigger download
//       const link = document.createElement("a");
//       link.href = imageUrl;
//       link.download = `ABHA-QR-${
//         adhaarSuccessData?.ABHANumber || Date.now()
//       }.png`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(imageUrl);

//       successToast("QR Code Downloaded Successfully");
//       setLoading(false);

//       return response.data;
//     } catch (error) {
//       errorToast(error.response?.data || error.message);
//       console.error(
//         "Error downloading QR:",
//         error.response?.data || error.message
//       );
//       setLoading(false);
//     }
//   };

//   const shareQR = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${url}/abha-integration/abha-qr-code-download`,
//         {
//           x_token: adhaarX_Token,
//           accessToken: adhaarAccessToken,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           responseType: "blob",
//         }
//       );

//       // Create blob and object URL for sharing
//       const blob = new Blob([response.data], { type: "image/png" });
//       const imageUrl = URL.createObjectURL(blob);

//       setQrImageUrl(imageUrl);
//       setQrBlob(blob);

//       // Generate shareable link (you might want to upload to your server and get a public URL)
//       // For now, this creates a temporary URL that can be shared
//       const shareUrl = `${window.location.origin}/shared-qr/${adhaarSuccessData?.ABHANumber}`;
//       setShareQRUrl(shareUrl);

//       setLoading(false);
//       return { imageUrl, shareUrl };
//     } catch (error) {
//       errorToast(error.response?.data || error.message);
//       console.error(
//         "Error generating QR for sharing:",
//         error.response?.data || error.message
//       );
//       setLoading(false);
//     }
//   };

//   const copyQRLink = async () => {
//     if (!shareQRUrl) {
//       await shareQR();
//     }

//     try {
//       await navigator.clipboard.writeText(
//         shareQRUrl ||
//           `${window.location.origin}/shared-qr/${adhaarSuccessData?.ABHANumber}`
//       );
//       successToast("QR Share Link Copied to Clipboard");
//     } catch (error) {
//       // Fallback for older browsers
//       const textArea = document.createElement("textarea");
//       textArea.value =
//         shareQRUrl ||
//         `${window.location.origin}/shared-qr/${adhaarSuccessData?.ABHANumber}`;
//       document.body.appendChild(textArea);
//       textArea.select();
//       document.execCommand("copy");
//       document.body.removeChild(textArea);
//       successToast("QR Share Link Copied to Clipboard");
//     }
//   };

//   const shareViaWebShare = async () => {
//     if (!qrBlob) {
//       await shareQR();
//     }

//     if (navigator.share && qrBlob) {
//       try {
//         const file = new File(
//           [qrBlob],
//           `ABHA-QR-${adhaarSuccessData?.ABHANumber}.png`,
//           {
//             type: "image/png",
//           }
//         );

//         await navigator.share({
//           title: "ABHA QR Code",
//           text: `ABHA Number: ${adhaarSuccessData?.ABHANumber}`,
//           files: [file],
//         });

//         successToast("QR Code Shared Successfully");
//       } catch (error) {
//         console.log("Error sharing:", error);
//         // Fallback to copy link if Web Share API fails
//         copyQRLink();
//       }
//     } else {
//       // Fallback to copy link if Web Share API is not supported
//       copyQRLink();
//     }
//   };

//   const downloadABHA = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${url}/abha-integration/abha-download`,
//         {
//           x_token: adhaarX_Token,
//           accessToken: adhaarAccessToken,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           responseType: "blob", // Handle binary data for ABHA card download
//         }
//       );

//       console.log("Response:", response);

//       // Create blob and download immediately
//       const blob = new Blob([response.data], { type: "image/png" }); // or 'image/png' depending on your API
//       const imageUrl = URL.createObjectURL(blob);

//       // Create download link and trigger download
//       const link = document.createElement("a");
//       link.href = imageUrl;
//       link.download = `ABHA-Card-${
//         adhaarSuccessData?.ABHANumber || Date.now()
//       }.png`; // or .png
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(imageUrl);

//       successToast("ABHA Card Downloaded Successfully");
//       setLoading(false);

//       return response.data;
//     } catch (error) {
//       errorToast(error.response?.data || error.message);
//       console.error(
//         "Error downloading ABHA:",
//         error.response?.data || error.message
//       );
//       setLoading(false);
//     }
//   };

//   return (
//     <div className=" flex flex-col mt-8">
//       <div className="h-full flex-1  flex  flex-col gap-11 items-center justify-start">
//         <div className="w-full flex flex-col gap-6 ">
//           <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
//             <div className="flex items-center justify-center w-20 h-20 rounded-full bg-[var(--abha-icon-bg)]">
//               <TickIcon />
//             </div>
//           </div>
//           <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
//             <label
//               className={`
//                  text-[length:var(--abha-method-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
//             >
//               ABHA Number Created Successfully!
//             </label>
//             <label
//               className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-sub-title-fw)] whitespace-nowrap`}
//             >
//               Your digital health identity is now ready to use
//             </label>
//           </div>
//         </div>

//         <div className="flex flex-col gap-6">
//           {/*options boxes*/}

//           <div className="flex flex-row gap-16">
//             <div className="flex flex-col gap-3">
//               <div className="flex flex-row gap-3">
//                 <div
//                   className="flex flex-col justify-center items-center gap-5 p-6 border
//           border-[var(--abha-method-card-border-color)] rounded-lg
//                 flex-1  cursor-pointer min-w-[250px] max-w-[700px]"
//                   onClick={downloadABHA}
//                 >
//                   <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-download-bg)] rounded-2xl">
//                     <DownloadIcon />
//                   </div>
//                   <div className="flex flex-col justify-center items-center gap-2 w-full text-center ">
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
//                     >
//                       Download Card
//                     </label>
//                     <label
//                       className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     >
//                       Get your digital ABHA card
//                     </label>
//                   </div>
//                 </div>

//                 {/* Updated Share QR Section with Dropdown */}
//                 <div className="relative group">
//                   <div
//                     className="flex flex-col justify-center items-center gap-5 p-6 border
//             border-[var(--abha-method-card-border-color)] rounded-lg
//                   flex-1   min-w-[250px] max-w-[700px] cursor-pointer"
//                   >
//                     <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-share-bg)] rounded-2xl">
//                       <ShareIcon />
//                     </div>
//                     <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
//                       <label
//                         className={`
//                    text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
//                       >
//                         Share QR
//                       </label>
//                       <label
//                         className={`text-[var(--abha-nav-fg)]
//                    text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                       >
//                         Share with healthcare providers
//                       </label>
//                     </div>
//                   </div>

//                   {/* Dropdown Menu */}
//                   <div className="absolute top-full left-0 mt-2 w-full bg-white border border-[var(--abha-method-card-border-color)] rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
//                     <div className="flex flex-col p-2 gap-1">
//                       <button
//                         onClick={shareViaWebShare}
//                         className="flex items-center gap-3 px-3 py-2 text-left hover:bg-gray-50 rounded-md transition-colors"
//                         disabled={loading}
//                       >
//                         <Share2Icon className="w-4 h-4" />
//                         <span className="text-sm">Share QR Code</span>
//                       </button>
//                       <button
//                         onClick={copyQRLink}
//                         className="flex items-center gap-3 px-3 py-2 text-left hover:bg-gray-50 rounded-md transition-colors"
//                         disabled={loading}
//                       >
//                         <CopyIcon className="w-4 h-4" />
//                         <span className="text-sm">Copy Share Link</span>
//                       </button>
//                       <button
//                         onClick={downloadQR}
//                         className="flex items-center gap-3 px-3 py-2 text-left hover:bg-gray-50 rounded-md transition-colors"
//                         disabled={loading}
//                       >
//                         <DownloadIcon className="w-4 h-4" />
//                         <span className="text-sm">Download QR</span>
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex flex-row gap-3">
//                 <div
//                   className="flex flex-col justify-center items-center gap-5 p-6 border
//           border-[var(--abha-method-card-border-color)] rounded-lg
//                 flex-1   min-w-[250px] max-w-[700px]"
//                 >
//                   <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-print-bg)] rounded-2xl">
//                     <PrintIcon />
//                   </div>
//                   <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
//                     >
//                       Print Card
//                     </label>
//                     <label
//                       className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     >
//                       Print physical copy
//                     </label>
//                   </div>
//                 </div>
//                 <div
//                   className="flex flex-col justify-center items-center gap-5 p-6 border
//           border-[var(--abha-method-card-border-color)] rounded-lg
//                 flex-1   min-w-[250px] max-w-[700px]"
//                 >
//                   <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-email-bg)] rounded-2xl">
//                     <EmailIcon />
//                   </div>
//                   <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
//                     >
//                       Email Details
//                     </label>
//                     <label
//                       className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     >
//                       Send to your email
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="flex flex-col justify-between min-w-[600px] max-w-[800px] h-full rounded-3xl p-8  text-white bg-[var(--primary)]">
//                 <div className="flex flex-row justify-between">
//                   <div className=" flex flex-col items-start gap-4 w-full text-center">
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
//                     >
//                       ABHA Health Card
//                     </label>
//                     <label
//                       className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     >
//                       Ayushman Bharat Digital Mission
//                     </label>
//                   </div>
//                   <div className="flex w-16 h-16 items-center justify-center bg-[var(--abha-health-bg)] rounded-2xl ">
//                     <HealthIcon className="bg-[var(--abha-health-bg)]" />
//                   </div>
//                 </div>
//                 <div className=" flex flex-col items-start gap-4 w-full text-center">
//                   <label
//                     className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                   >
//                     ABHA Number
//                   </label>
//                   <label
//                     className={`
//                  text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
//                   >
//                     {adhaarSuccessData?.ABHANumber ?? "--"}
//                   </label>
//                 </div>
//                 <div className=" flex flex-col items-start gap-4 w-full text-center">
//                   <label
//                     className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                   >
//                     ABHA Address
//                   </label>
//                   <label
//                     className={`
//                  text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
//                   >
//                     {adhaarSuccessData?.preferredAddress ?? "--"}
//                   </label>
//                 </div>
//                 <div className="flex flex-row justify-between">
//                   <div className=" flex flex-col items-start gap-4 w-full text-center">
//                     <label
//                       className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     >
//                       Issued On
//                     </label>
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] whitespace-nowrap`}
//                     >
//                       {moment(new Date()).format("MMM DD, YYYY")}
//                     </label>
//                   </div>
//                   <div className="flex w-16 h-16 items-center justify-center bg-white rounded-lg p-2">
//                     <img
//                       src={QR} // put your image in public/images
//                       alt="ABHA QR"
//                       className="w-full h-full rounded-[4px] shadow-lg"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/*info boxes*/}
//           <div className="w-full flex flex-row gap-3 ">
//             <div className="flex-1 w-full border flex flex-col bg-[var(--abha-caution-bg)] border-[var(--primary)] rounded-lg  gap-[10px] p-5">
//               <div className=" flex flex-row gap-[10px]">
//                 <InfoIcon />
//                 <ul className="flex flex-col gap-2">
//                   <label
//                     className={`
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
//                   >
//                     Important Information
//                   </label>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Keep your ABHA Number safe and secure
//                   </li>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Use this for all your healthcare services
//                   </li>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • You can link multiple healthcare providers
//                   </li>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Access your health records anytime, anywhere
//                   </li>
//                 </ul>
//               </div>
//             </div>
//             <div className="flex-1 w-full border flex flex-col bg-[var(--abha-card2-fg)] border-[var(--customer-consol-border-color)] rounded-lg  gap-[10px] p-5">
//               <div className=" flex flex-row gap-[10px]">
//                 <BulbIcon />
//                 <ul className="flex flex-col gap-2">
//                   <label
//                     className={`
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
//                   >
//                     What's Next?
//                   </label>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Link your healthcare providers to start building your
//                     health record
//                   </li>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Download the ABHA mobile app for easy access
//                   </li>
//                   <li
//                     className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
//                     key="q"
//                   >
//                     • Share your ABHA Address with doctors and hospitals
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           bottom: "0",
//         }}
//         className="flex flex-row gap-3 w-full justify-end  sticky bg-white py-4 mt-auto "
//       >
//         <AddButton
//           prefixIcon={false}
//           // ref={submitRef}
//           onclkFn={() => closeModal()}
//           text={<span>Go To Dashboard</span>}
//           className="
//     flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
//      cursor-pointer
//     text-[var(--primary-button-bg-color)]
//     border border-[var(--primary-button-bg-color)]
//     text-[length:var(--primary-button-create-fs)]
//     font-[var(--primary-button-font-weight)]
//     "
//           type="button"
//         />
//         <AddButton
//           prefixIcon={false}
//           // ref={submitRef}
//           onclkFn={() => {
//             setStatus("Method Selection");
//             setPosition(0);
//           }}
//           text={<span>Create Another ABHA</span>}
//           className="
//     flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
//     bg-[var(--primary-button-bg-color)] cursor-pointer
//     text-[var(--primary-button-fg-color)]
//     border border-[var(--primary-button-bg-color)]
//     hover:bg-[var(--primary-button-hover-color)]
//     text-[length:var(--primary-button-create-fs)]
//     font-[var(--primary-button-font-weight)]
//     "
//           type="button"
//         />
//       </div>
//     </div>
//   );
// }

function Confirmation({
  closeModal,
  setStatus,
  setPosition,
  adhaarSuccessData,
  adhaarX_Token,
  adhaarAccessToken,
  newABHAaddress,
}) {
  const [loading, setLoading] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState(null);
  const [qrBlob, setQrBlob] = useState(null);

  const downloadQR = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-qr-code-download`,
        {
          x_token: adhaarX_Token,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob", // This is crucial for binary data
        }
      );

      console.log("Response:", response);

      // Create blob and download immediately
      const blob = new Blob([response.data], { type: "image/png" });
      const imageUrl = URL.createObjectURL(blob);

      // Create download link and trigger download
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `ABHA-QR-${
        adhaarSuccessData?.ABHANumber || Date.now()
      }.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(imageUrl);

      successToast("QR Code Downloaded Successfully");
      setLoading(false);

      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error downloading QR:",
        error.response?.data || error.message
      );
      setLoading(false);
    }
  };

  const downloadABHA = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-download`,
        {
          x_token: adhaarX_Token,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob", // Handle binary data for ABHA card download
        }
      );

      console.log("Response:", response);

      // Create blob and download immediately
      const blob = new Blob([response.data], { type: "image/png" }); // or 'image/png' depending on your API
      const imageUrl = URL.createObjectURL(blob);

      // Create download link and trigger download
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `ABHA-Card-${
        adhaarSuccessData?.ABHANumber || Date.now()
      }.png`; // or .png
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(imageUrl);

      successToast("ABHA Card Downloaded Successfully");
      setLoading(false);

      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error downloading ABHA:",
        error.response?.data || error.message
      );
      setLoading(false);
    }
  };
  return (
    <div className=" flex flex-col mt-8">
      <div className="h-full flex-1  flex  flex-col gap-11 items-center justify-start">
        <div className="w-full flex flex-col gap-6 ">
          <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-[var(--abha-icon-bg)]">
              <TickIcon />
            </div>
          </div>
          <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
            <label
              className={`
                 text-[length:var(--abha-method-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
            >
              ABHA Number Created Successfully!
            </label>
            <label
              className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-sub-title-fw)] whitespace-nowrap`}
            >
              Your digital health identity is now ready to use
            </label>
          </div>
        </div>

        <div className="flex flex-col gap-6">
          {/*options boxes*/}

          <div className="flex flex-row gap-16">
            <div className="flex flex-col gap-3">
              <div className="flex flex-row gap-3">
                <div
                  className="flex flex-col justify-center items-center gap-5 p-6 border
          border-[var(--abha-method-card-border-color)] rounded-lg
                flex-1  cursor-pointer min-w-[250px] max-w-[700px]"
                  onClick={downloadABHA}
                >
                  <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-download-bg)] rounded-2xl">
                    <DownloadIcon />
                  </div>
                  <div className="flex flex-col justify-center items-center gap-2 w-full text-center ">
                    <label
                      className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                    >
                      Download Card
                    </label>
                    <label
                      className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Get your digital ABHA card
                    </label>
                  </div>
                </div>
                <div
                  onClick={downloadQR}
                  className="flex flex-col justify-center items-center gap-5 p-6 border
          border-[var(--abha-method-card-border-color)] rounded-lg
                flex-1   min-w-[250px] max-w-[700px] cursor-pointer"
                >
                  <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-share-bg)] rounded-2xl">
                    <ShareIcon />
                  </div>
                  <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
                    <label
                      className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                    >
                      Share QR
                    </label>
                    <label
                      className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Share with healthcare providers
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-3">
                <div
                  className="flex flex-col justify-center items-center gap-5 p-6 border
          border-[var(--abha-method-card-border-color)] rounded-lg
                flex-1   min-w-[250px] max-w-[700px]"
                >
                  <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-print-bg)] rounded-2xl">
                    <PrintIcon />
                  </div>
                  <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
                    <label
                      className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                    >
                      Print Card
                    </label>
                    <label
                      className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Print physical copy
                    </label>
                  </div>
                </div>
                <div
                  className="flex flex-col justify-center items-center gap-5 p-6 border
          border-[var(--abha-method-card-border-color)] rounded-lg
                flex-1   min-w-[250px] max-w-[700px]"
                >
                  <div className="flex  justify-center items-center w-16 h-16 bg-[var(--abha-email-bg)] rounded-2xl">
                    <EmailIcon />
                  </div>
                  <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
                    <label
                      className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                    >
                      Email Details
                    </label>
                    <label
                      className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Send to your email
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex flex-col justify-between min-w-[600px] max-w-[800px] h-full rounded-3xl p-8  text-white bg-[var(--primary)]">
                <div className="flex flex-row justify-between">
                  <div className=" flex flex-col items-start gap-4 w-full text-center">
                    <label
                      className={`
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
                    >
                      ABHA Health Card
                    </label>
                    <label
                      className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Ayushman Bharat Digital Mission
                    </label>
                  </div>
                  <div className="flex w-16 h-16 items-center justify-center bg-[var(--abha-health-bg)] rounded-2xl ">
                    <HealthIcon className="bg-[var(--abha-health-bg)]" />
                  </div>
                </div>
                <div className=" flex flex-col items-start gap-4 w-full text-center">
                  <label
                    className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                  >
                    ABHA Number
                  </label>
                  <label
                    className={`
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
                  >
                    {adhaarSuccessData?.ABHANumber ?? "--"}
                  </label>
                </div>
                <div className=" flex flex-col items-start gap-4 w-full text-center">
                  <label
                    className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                  >
                    ABHA Address
                  </label>
                  <label
                    className={`
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                  >
                    {newABHAaddress ??
                      adhaarSuccessData?.preferredAddress ??
                      "--"}
                  </label>
                </div>
                <div className="flex flex-row justify-between">
                  <div className=" flex flex-col items-start gap-4 w-full text-center">
                    <label
                      className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    >
                      Issued On
                    </label>
                    <label
                      className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] whitespace-nowrap`}
                    >
                      {moment(new Date()).format("MMM DD, YYYY")}
                    </label>
                  </div>
                  <div className="flex w-16 h-16 items-center justify-center bg-white rounded-lg p-2">
                    <img
                      src={QR} // put your image in public/images
                      alt="ABHA QR"
                      className="w-full h-full rounded-[4px] shadow-lg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*info boxes*/}
          <div className="w-full flex flex-row gap-3 ">
            <div className="flex-1 w-full border flex flex-col bg-[var(--abha-caution-bg)] border-[var(--primary)] rounded-lg  gap-[10px] p-5">
              <div className=" flex flex-row gap-[10px]">
                <InfoIcon />
                <ul className="flex flex-col gap-2">
                  <label
                    className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
                  >
                    Important Information
                  </label>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Keep your ABHA Number safe and secure
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Use this for all your healthcare services
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • You can link multiple healthcare providers
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Access your health records anytime, anywhere
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex-1 w-full border flex flex-col bg-[var(--abha-card2-fg)] border-[var(--customer-consol-border-color)] rounded-lg  gap-[10px] p-5">
              <div className=" flex flex-row gap-[10px]">
                <BulbIcon />
                <ul className="flex flex-col gap-2">
                  <label
                    className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
                  >
                    What's Next?
                  </label>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Link your healthcare providers to start building your
                    health record
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Download the ABHA mobile app for easy access
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Share your ABHA Address with doctors and hospitals
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          bottom: "0",
        }}
        className="flex flex-row gap-3 w-full justify-end  sticky bg-white py-4 mt-auto "
      >
        <AddButton
          prefixIcon={false}
          // ref={submitRef}
          onclkFn={() => closeModal()}
          text={<span>Go To Dashboard</span>}
          className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
          type="button"
        />
        <AddButton
          prefixIcon={false}
          // ref={submitRef}
          onclkFn={() => {
            setStatus("Method Selection");
            setPosition(0);
          }}
          text={<span>Create Another ABHA</span>}
          className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
          type="button"
        />
      </div>
    </div>
  );
}

//

export default Confirmation;
